<div class="relative h-full bg-slate-50/50 overflow-auto flex flex-col font-sans">

  <!------------------------------ Curved Header with Premium Gradient ------------------------------>
  <div
    class="absolute top-0 left-0 right-0 h-[220px] bg-gradient-to-r from-(--main-color) to-(--soft-color) rounded-b-[2.5rem] shadow-md z-0 transition-all duration-300">
  </div>

  <!---------------------------------------- Header Navigation & Title ---------------------------------->
  <div class="relative z-10 flex-none px-4 pt-4 pb-2">
    <div class="flex items-center justify-between">
      <button (click)="goback()"
        class="w-10 h-10 p-1 bg-white/95 backdrop-blur-sm rounded-full shadow-md flex items-center justify-center text-slate-700 hover:text-amber-500 active:scale-95 transition-all">
        <img src="icons/arrow_back_black.svg" class="w-full h-full" />
      </button>
      <h1 class="text-lg font-extrabold text-slate-800 tracking-wide">
        {{ currentLang === "TH" ? "ประวัติการเข้าจอด" : "Parking History" }}
      </h1>
      <div class="w-10"></div>
    </div>
  </div>

  <!---------------------------------------- Original Document Icon Header Graphic ------------------------------>
  <div class="relative flex flex-col items-center pb-4 pt-1 z-10 flex-none">
    <div class="p-2 bg-white rounded-full shadow-lg shadow-gray-200/50 flex items-center justify-center">
      <div class="w-[72px] h-[72px] p-3.5 bg-white shadow rounded-full">
        <img src="icons/Parking-history/doccument.png" alt="document"
          class="w-full h-full object-contain drop-shadow-sm" />
      </div>
    </div>
  </div>

  <!---------------------------------------- Main Scrollable Content Area ---------------------------------->
  <div class="relative z-10 flex-1 custom-scrollbar flex flex-col pb-6">
    <div class="px-4 space-y-4">

      <!-------------------------------- Date Selection & Search Panel ---------------------------------->
      <div class="bg-white/95 backdrop-blur-sm rounded-2xl shadow-xl border border-slate-100/50 p-4">
        <div class="flex flex-col gap-4">
          <div class="grid grid-cols-2 gap-3">

            <!-- Start Date Picker -->
            <div class="space-y-1">
              <label class="block text-xs font-bold text-slate-500 pl-1">
                {{ currentLang === "TH" ? "เริ่มต้น" : "Start Date"}}
              </label>
              <div class="relative">
                <input matInput [matDatepicker]="startPicker" [max]="endDateMoment || todayMoment"
                  [min]="minStartDateMoment" [(ngModel)]="startDateMoment" readonly placeholder="DD/MM/YYYY"
                  class="w-full bg-slate-50/80 border border-slate-200 text-sm rounded-xl pl-3 pr-10 py-2.5 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300 cursor-pointer"
                  (click)="startPicker.open()" (dateChange)="onStartDateChange($event)" />
                <mat-datepicker-toggle matSuffix [for]="startPicker"
                  class="absolute top-1/2 right-1 -translate-y-1/2 scale-90"></mat-datepicker-toggle>
                <mat-datepicker #startPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
              </div>
            </div>

            <!-- End Date Picker -->
            <div class="space-y-1">
              <label class="block text-xs font-bold text-slate-500 pl-1">
                {{ currentLang === "TH" ? "สิ้นสุด" : "End Date"}}
              </label>
              <div class="relative">
                <input matInput [matDatepicker]="endPicker" [max]="todayMoment"
                  [min]="startDateMoment || minStartDateMoment" [(ngModel)]="endDateMoment" readonly
                  placeholder="DD/MM/YYYY"
                  class="w-full bg-slate-50/80 border border-slate-200 text-sm rounded-xl pl-3 pr-10 py-2.5 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300 cursor-pointer"
                  (click)="endPicker.open()" (dateChange)="onEndDateChange($event)" />
                <mat-datepicker-toggle matSuffix [for]="endPicker"
                  class="absolute top-1/2 right-1 -translate-y-1/2 scale-90"></mat-datepicker-toggle>
                <mat-datepicker #endPicker panelClass="modern-yellow-datepicker"></mat-datepicker>
              </div>
            </div>

          </div>

          <!-- Green Action Button matching application style standard -->
          <button (click)="searchParkingHistory()"
            class="w-full bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 font-extrabold py-2.5 rounded-xl shadow-lg shadow-(--main-color)/20 transition-all flex justify-center items-center gap-2">
            <img src="icons/search_black.svg" class="w-5 h-5" />
            <span>{{ currentLang === "TH" ? "ดึงข้อมูลประวัติ" : "Fetch History"}}</span>
          </button>
        </div>
      </div>

      <!-------------------------------- Interactive Control Center ---------------------------------->
      <div class="flex gap-2">
        <button (click)="toggleDashboard()"
          [ngClass]="showDashboard ? 'bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 shadow-md shadow-(--main-color)/20 font-extrabold' : 'bg-white text-slate-600 border border-slate-100'"
          class="flex-1 py-2 rounded-xl text-xs font-bold transition-all flex items-center justify-center gap-1.5 active:scale-95">
          <img src="icons/monitoring_black.svg" class="w-5 h-5" />
          <span>{{ currentLang === "TH" ? "แดชบอร์ดสรุป" : "Dashboard" }}</span>
        </button>
        <button (click)="toggleFilters()"
          [ngClass]="showTableFilters ? 'bg-gradient-to-r from-(--main-color) to-(--soft-color) text-slate-800 shadow-md shadow-(--main-color)/20 font-extrabold' : 'bg-white text-slate-600 border border-slate-100'"
          class="flex-1 py-2 rounded-xl text-xs font-bold transition-all flex items-center justify-center gap-1.5 active:scale-95">
          <img src="icons/filter_list_black.svg" />
          <span>{{ currentLang === "TH" ? "ตัวกรองขั้นสูง" : "Filters" }}</span>
          <span *ngIf="searchQuery || selectedSite || selectedVehicleType"
            class="w-1.5 h-1.5 rounded-full bg-red-500 animate-ping"></span>
        </button>
      </div>

      <!-------------------------------- dynamic stats dashboard ---------------------------------->
      <div *ngIf="showDashboard"
        class="bg-white/95 backdrop-blur-sm border border-slate-100/50 rounded-2xl p-4 shadow-xl animate-fade-in-up">
        <div class="flex items-center gap-2 mb-3">
          <div class="w-1.5 h-4 bg-(--main-color) rounded-full"></div>
          <span class="text-xs font-bold text-slate-700 uppercase tracking-wide">
            {{ currentLang === "TH" ? "สถิติการใช้งานในช่วงเวลา" : "Usage Overview Statistics" }}
          </span>
        </div>
        <div class="grid grid-cols-4 gap-2">

          <!-- Stat 1: Total Times -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 p-1 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/local_parking_black.svg" class="w-full h-full" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ totalSessions }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH" ? "จำนวนครั้ง" : "Sessions"
              }}</span>
          </div>

          <!-- Stat 2: Total Hours -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 p-1 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/schedule_black.svg" class="w-full h-full" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ totalHours }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH" ? "รวม (ชม.)" : "Total Hrs"
              }}</span>
          </div>

          <!-- Stat 3: Avg Duration -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 p-1 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/timelapse_black.svg" class="w-full h-full" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ averageTime }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH"
              ? "เฉลี่ย (น.)"
              : "Avg Mins" }}</span>
          </div>

          <!-- Stat 4: Visited Sites -->
          <div
            class="group flex flex-col items-center bg-slate-50/50 rounded-xl p-2 transition-all hover:bg-slate-50 border border-slate-100/30">
            <div
              class="w-8 h-8 p-1 rounded-full bg-(--main-color)/15 flex items-center justify-center mb-1 group-hover:scale-110 transition-transform">
              <img src="icons/domain_black.svg" class="w-full h-full" />
            </div>
            <span class="text-sm font-extrabold text-slate-800">{{ uniqueSitesCount }}</span>
            <span class="text-[9px] font-bold text-slate-400 mt-0.5">{{ currentLang === "TH" ? "จุดจอด" : "Sites"
              }}</span>
          </div>

        </div>
      </div>

      <!-------------------------------- Advanced Filter Panel ---------------------------------->
      <div *ngIf="showTableFilters"
        class="bg-white rounded-2xl border border-slate-100 p-4 shadow-lg space-y-4 animate-fade-in-up">
        <!-- Filter Header with Reset -->
        <div class="flex justify-between items-center">
          <span class="text-xs font-bold text-slate-700">
            {{ currentLang === "TH" ? "ค้นหาและกรองข้อมูล" : "Search & Filtering Options" }}
          </span>
          <button *ngIf="searchQuery || selectedSite || selectedVehicleType"
            (click)="searchQuery = ''; selectedSite = ''; searchFieldText = ''; selectedVehicleType = ''"
            class="text-xs font-bold text-amber-600 hover:text-amber-700 transition-colors flex items-center gap-0.5 active:scale-95">
            <img src="icons/restart_alt_black.svg" class="w-4 h-4" />
            <span>{{ currentLang === "TH" ? "รีเซ็ตตัวกรอง" : "Reset" }}</span>
          </button>
        </div>

        <!-- Search input for License Plate -->
        <div class="space-y-1">
          <label class="block text-xs font-bold text-slate-500 pl-1">
            {{ currentLang === "TH" ? "ค้นหาด้วยเลขทะเบียนรถ" : "Search License Plate" }}
          </label>
          <div class="relative">
            <div class="absolute left-3 top-1/2 -translate-y-1/2">
              <img src="icons/search_slate.svg" class="w-4 h-4" />
            </div>
            <input type="text" [(ngModel)]="searchQuery"
              placeholder="{{ currentLang === 'TH' ? 'เช่น กข 1234...' : 'e.g. AB 1234...' }}"
              class="w-full bg-slate-50/50 border border-slate-200 text-sm rounded-xl pl-10 pr-4 py-2 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300" />
          </div>
        </div>

        <!-- Searchable Autocomplete Dropdown (Combo Box) for Site Name -->
        <div class="space-y-1">
          <label class="block text-xs font-bold text-slate-500 pl-1">
            {{ currentLang === "TH" ? "สถานที่ / จุดจอด" : "Site Name" }}
          </label>
          <div class="relative">
            <div class="absolute left-3 top-1/2 -translate-y-1/2">
              <img src="icons/domain_slate.svg" class="w-4 h-4" />
            </div>
            <input type="text" [(ngModel)]="searchFieldText" (focus)="isSiteDropdownOpen = true"
              (blur)="closeDropdowns()"
              placeholder="{{ currentLang === 'TH' ? 'พิมพ์ค้นหาสถานที่...' : 'Type to search site...' }}"
              class="w-full bg-slate-50/50 border border-slate-200 text-sm rounded-xl pl-10 pr-10 py-2 text-slate-800 outline-none focus:bg-white focus:border-(--main-color) focus:ring-2 focus:ring-(--main-color)/30 transition-all placeholder:text-slate-300" />
            <div class="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none transition-transform duration-300"
              [ngClass]="{'rotate-180': isSiteDropdownOpen}">
              <img src="icons/expand_more_slate_dark.svg" />
            </div>

            <!-- Fake Dropdown Menu Options -->
            <div *ngIf="isSiteDropdownOpen && filteredSiteOptions.length > 0" (mousedown)="$event.preventDefault()"
              class="absolute z-30 left-0 right-0 mt-1 max-h-48 overflow-y-auto bg-white border border-slate-100 rounded-xl shadow-2xl custom-scrollbar">
              <div *ngFor="let site of filteredSiteOptions" (click)="selectSite(site)"
                [ngClass]="selectedSite === site ? 'bg-amber-50 text-amber-700 font-bold' : 'hover:bg-slate-50 text-slate-700'"
                class="px-4 py-2.5 text-sm cursor-pointer transition-colors flex items-center justify-between">
                <span>{{ site }}</span>
                <img *ngIf="selectedSite === site" src="icons/check_orange.svg" class="w-4 h-4" />
              </div>
            </div>
          </div>
        </div>

        <!-- Vehicle Type Filter Chips -->
        <div class="space-y-1.5" *ngIf="vehicleTypeOptions.length > 0">
          <label class="block text-xs font-bold text-slate-500 pl-1">
            {{ currentLang === "TH" ? "ประเภทรถ" : "Vehicle Type" }}
          </label>
          <div class="flex flex-wrap gap-1.5 pb-1">
            <button (click)="selectedVehicleType = ''"
              [ngClass]="!selectedVehicleType ? 'bg-(--main-color)/15 text-slate-800 border-(--main-color)/40 font-bold' : 'bg-slate-50 text-slate-600 border-slate-200'"
              class="px-3 py-1 rounded-full text-xs border transition-all active:scale-95">
              {{ currentLang === "TH" ? "ทั้งหมด" : "All" }}
            </button>
            <button *ngFor="let type of vehicleTypeOptions" (click)="selectVehicleType(type)"
              [ngClass]="selectedVehicleType === type ? 'bg-(--main-color)/15 text-slate-800 border-(--main-color)/40 font-bold' : 'bg-slate-50 text-slate-600 border-slate-200'"
              class="px-3 py-1 rounded-full text-xs border transition-all active:scale-95">
              {{ type }}
            </button>
          </div>
        </div>

      </div>

      <!-------------------------------- Parking History Cards list ---------------------------------->
      <div class="space-y-4">

        <!-- Tickets -->
        <div *ngFor="let transaction of filteredParkingHistory"
          class="bg-white rounded-2xl shadow-md border border-slate-100 overflow-hidden animate-fade-in-up transition-all hover:shadow-lg">
          <!-- Card Header (Site Name & Type badge styled with main and soft gradient) -->
          <div
            class="bg-gradient-to-r from-(--main-color) to-(--soft-color) px-4 py-3 border-b border-slate-100/50 flex justify-between items-center text-slate-800 font-bold">
            <div class="flex items-center gap-2">
              <img src="icons/domain_slate.svg" />
              <span class="font-extrabold text-slate-800 text-sm tracking-wide">{{ transaction.siteName }}</span>
            </div>
            <span
              class="text-[10px] font-extrabold px-2 py-0.5 bg-white/40 border border-white/20 text-slate-800 rounded-md">
              {{ transaction.vehicleTypeName }}
            </span>
          </div>

          <!-- Card Content -->
          <div class="p-4 space-y-3">
            <div class="flex justify-between items-center">
              <div>
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                  "ทะเบียนรถ" : "License Plate" }}</p>
                <p class="text-base font-extrabold text-slate-800 mt-0.5">{{ transaction.entryLicense }}</p>
              </div>
              <div class="text-right">
                <p class="text-[10px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                  "เวลารวม" : "Duration" }}</p>
                <p class="text-sm font-extrabold text-slate-800 mt-0.5 flex items-center justify-end gap-0.5">
                  <span class="text-[#c97c1e] font-black text-base">{{ hour(transaction.totalTime) | number : "1.0-0"
                    }}</span>
                  <span class="text-slate-500 font-bold text-xs">{{ currentLang === "TH" ? "ชม." : "hr" }}</span>
                  <span class="text-[#c97c1e] font-black text-base ml-1">{{ transaction.totalTime % 60 }}</span>
                  <span class="text-slate-500 font-bold text-xs">{{ currentLang === "TH" ? "น." : "m" }}</span>
                </p>
              </div>
            </div>

            <!-- Elegant Visual Dotted Timeline -->
            <div class="border-t border-dashed border-slate-100 pt-3 flex flex-col gap-2">

              <!-- Entry Date & Time -->
              <div class="flex items-start gap-2.5">
                <div
                  class="w-2.5 h-2.5 rounded-full bg-emerald-500 mt-1 border-2 border-white shadow-sm shadow-emerald-400">
                </div>
                <div class="flex-1">
                  <div class="flex justify-between items-center">
                    <span class="text-[10px] font-extrabold text-emerald-600 uppercase tracking-wider">
                      {{ currentLang === "TH" ? "ทางเข้า" : "Entry Point" }}
                    </span>
                    <span class="text-[10px] font-bold text-slate-400">
                      {{ transaction.entryDate | date : "dd/MM/yyyy HH:mm" }}
                    </span>
                  </div>
                </div>
              </div>

              <!-- Exit Date & Time -->
              <div class="flex items-start gap-2.5">
                <div class="w-2.5 h-2.5 rounded-full bg-rose-500 mt-1 border-2 border-white shadow-sm shadow-rose-400">
                </div>
                <div class="flex-1">
                  <div class="flex justify-between items-center">
                    <span class="text-[10px] font-extrabold text-rose-500 uppercase tracking-wider">
                      {{ currentLang === "TH" ? "ทางออก" : "Exit Point" }}
                    </span>
                    <span class="text-[10px] font-bold text-slate-400">
                      {{ transaction.exitDate | date : "dd/MM/yyyy HH:mm" }}
                    </span>
                  </div>
                </div>
              </div>

            </div>

            <!-- Advanced Expanded Details Section -->
            <div *ngIf="statusOpenDetails === transaction.id"
              class="mt-3 pt-3 border-t border-slate-100 grid grid-cols-2 gap-2 text-sm animate-fade-in-up">
              <div class="bg-slate-50 p-2.5 rounded-xl border border-slate-100/40">
                <p class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                  "ตู้เข้า" : "Entry Gate" }}</p>
                <p class="font-extrabold text-slate-700 text-xs mt-0.5">{{ transaction.entryGateName || '-' }}</p>
              </div>
              <div class="bg-slate-50 p-2.5 rounded-xl border border-slate-100/40">
                <p class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                  "ตู้ออก" : "Exit Gate" }}</p>
                <p class="font-extrabold text-slate-700 text-xs mt-0.5">{{ transaction.exitGateName || '-' }}</p>
              </div>
              <div
                class="col-span-2 bg-slate-50 p-2.5 rounded-xl border border-slate-100/40 flex justify-between items-center">
                <span class="text-[9px] font-bold text-slate-400 uppercase tracking-wider">{{ currentLang === "TH" ?
                  "ประเภทบัตร" : "Card Type" }}</span>
                <span class="font-extrabold text-slate-700 text-xs">{{ transaction.cardTypeName || '-' }}</span>
              </div>
            </div>

          </div>

          <!-- Bottom Expand Chevron Button -->
          <div (click)="openDetails(transaction.id)"
            class="bg-slate-50/50 py-2.5 flex justify-center items-center cursor-pointer hover:bg-slate-100/80 transition-colors border-t border-slate-100/50">
            <div [ngClass]="{'rotate-180': statusOpenDetails === transaction.id}"
              class="transition-transform duration-300">
              <img src="icons/expand_more_slate_dark.svg" />
            </div>
          </div>

        </div>

        <!-- Elegant Empty State -->
        <div *ngIf="!isLoading && filteredParkingHistory.length === 0"
          class="flex flex-col items-center justify-center py-16 px-4 bg-white rounded-2xl shadow-sm border border-slate-100 opacity-80 animate-fade-in">
          <div class="w-16 h-16 rounded-full bg-(--main-color)/10 flex items-center justify-center mb-3">
            <img src="icons/receipt_slate.svg" />
          </div>
          <p class="text-slate-700 font-bold text-sm text-center">
            {{ currentLang === "TH" ? "ไม่พบประวัติการเข้าจอด" : "No parking history found" }}
          </p>
          <p class="text-slate-400 text-xs mt-1 text-center">
            {{ currentLang === "TH"
            ? "ลองค้นหาด้วยวันหรือตัวกรองอื่นๆ เพิ่มเติม"
            : "Try shifting dates or modifying filters" }}
          </p>
        </div>

      </div>

    </div>
  </div>

</div>

<!-- Loading overlay at the very bottom outside the main container wrapper -->
<app-pss-loading *ngIf="isLoading"></app-pss-loading>